import React, { useRef, useEffect, useState } from 'react';


const MoreText = ({ text, typeMoreText, widthText }) => {

  const textRef = useRef()
  const [isShowMore, setIsShowMore] = useState(false)
  const [contentText, setContentText] = useState(252)
  useEffect(() => {
    if (text)
      linkify(text)
  }, [text, contentText])

  const linkify = (text) => {
    if (text) {
      var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
      var saltoRegex = /[^\r\n]+/g
      var textWithLink = text.replace(urlRegex, (url) => { return '<a href="' + url + '"  target="_blank">' + url + '</a>'; })
      var textWithEnter = textWithLink.replace(saltoRegex, (salto) => { return salto + '</br>'; })
      textRef.current.innerHTML = textWithEnter
    }
  }

  return (
    <div className={isShowMore ? 'show-more' : 'show-lesss'}>
      <div ref={textRef}></div>
    </div>
  )
}

export default MoreText;